import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Save Supplier Info
export async function saveRefund(data) {
  return axiosInstance.post(`${backendUrl}/api/refunds`, data);
}


// Save Supplier Info
export async function updateRefund(refundId, data) {
  return axiosInstance.put(`${backendUrl}/api/refunds/${refundId}`, data);
}

// Fetch Payment method
export async function getPaymentMethod() {
  return axiosInstance.get(`${backendUrl}/api/lookup-values/type/REFUND_METHOD`);
}

export async function getAllRefunds() {
  return axiosInstance.get(`${backendUrl}/api/refunds`);
}


export async function updateRefundStatus(refundId, status, data) {
  return axiosInstance.put(`${backendUrl}/api/refunds/${refundId}/${status}`, data);
}

export async function getMyRefunds(userId) {
  return axiosInstance.get(`${backendUrl}/api/refunds/user/${userId}`);
}


